import React from 'react';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { urlMap, urlConstructor } from 'routes/urlMap';
import { getUser } from 'selectors';
import { faFile } from '@fortawesome/pro-regular-svg-icons';
import { canAccessLookerReport } from 'utilities/user/permissions';
import getText from 'context/language/getText';
import { NavGroup } from '../components';

export const ReportsLink = () => {
  const user = useSelector(getUser);
  const hasAccessToLookerReport = canAccessLookerReport(user);
  const lookerReportUrl = get(user, 'customer.lookerReportUrl');

  const reportsLinks = [{
    textPath: 'navbar.reports.transactions',
    url: urlConstructor(urlMap.ACCOUNT_REPORTS),
    displayPath: `/employers/${user.id}/accounts`,
    name: 'reports-transactions'
  }, {
    textPath: 'navbar.reports.jobs',
    url: urlConstructor(urlMap.REPORT_ATTENDANCE_ALL),
    displayPath: '/employers/time_and_attendance',
    name: 'reports-jobs'
  }, {
    textPath: 'navbar.reports.summary',
    url: urlConstructor(urlMap.SUMMARY_REPORT_ALL),
    displayPath: '/reporting/summary-report',
    name: 'reports-summary'
  }, {
    textPath: 'navbar.reports.invoice',
    url: urlConstructor(urlMap.INVOICE_REPORT_ALL),
    displayPath: '/reporting/invoice_report',
    name: 'reports-invoice'
  }];

  if (hasAccessToLookerReport && lookerReportUrl) {
    reportsLinks.push({
      textPath: 'navbar.reports.enterpriseOverview',
      url: urlConstructor(urlMap.ENTERPRISE_OVERVIEW),
      name: 'reports-enterprise'
    });
  }

  return (
    <NavGroup
      links={reportsLinks}
      icon={faFile}
      label={getText('navbar.reports.title')}
      name="reports"
    />
  );
};
